import type { InviteRegisterPayload, User, UserUpdatePayload } from "../types";
import { api } from "./core";

type VerifyCodeResult =
  | { verified: false; message: string }
  | { verified: true; message: string; user: User; access_token: string };

export const authApi = {
  me: () => api<User>("/me"),
  updateMe: (payload: UserUpdatePayload) =>
    api<User>("/me", { method: "PATCH", body: JSON.stringify(payload) }),
  logout: () => api<void>("/auth/logout", { method: "POST" }),
  login: (payload: { email: string; password: string }) =>
    api<{ user: User; access_token: string }>("/auth/login", { method: "POST", body: JSON.stringify(payload) }),
  register: (payload: { email: string; password: string; display_name: string }) =>
    api<{ user: User; access_token: string }>("/auth/register", { method: "POST", body: JSON.stringify(payload) }),
  registerWithInvite: (payload: InviteRegisterPayload) =>
    api<{ user: User; access_token: string }>("/auth/register/invite", { method: "POST", body: JSON.stringify(payload) }),
  sendVerificationCode: (email: string) =>
    api<{ verified: boolean; message: string }>("/auth/verify/send", { method: "POST", body: JSON.stringify({ email }) }),
  verifyCode: (email: string, code: string) =>
    api<VerifyCodeResult>("/auth/verify/check", { method: "POST", body: JSON.stringify({ email, code }) }),
  getVerificationCooldown: (email: string) =>
    api<{ seconds_remaining: number }>(`/auth/verify/cooldown?email=${encodeURIComponent(email)}`),
};
